import React from 'react';
import { Loader2, RefreshCw, Wrench } from 'lucide-react';
import type { ToolInfo } from '../api/agent';

interface AvailableToolsSectionProps {
  tools: ToolInfo[];
  loading: boolean;
  onRefresh: () => void;
}

export const AvailableToolsSection: React.FC<AvailableToolsSectionProps> = ({
  tools,
  loading,
  onRefresh,
}) => (
  <div className="mt-6">
    <div className="flex items-center justify-between mb-4">
      <h4 className="text-sm font-medium text-slate-600">사용 가능한 도구</h4>
      <button
        onClick={onRefresh}
        disabled={loading}
        className="text-blue-500 hover:text-blue-600 text-xs flex items-center gap-1 disabled:opacity-50"
      >
        <RefreshCw size={12} className={loading ? 'animate-spin' : ''} />
        새로고침
      </button>
    </div>
    {loading ? (
      <div className="flex items-center justify-center py-8">
        <Loader2 size={20} className="animate-spin text-slate-400" />
      </div>
    ) : tools.length === 0 ? (
      <div className="text-center text-slate-400 py-8">
        <Wrench size={32} className="mx-auto mb-2 opacity-50" />
        <p className="text-sm">사용 가능한 도구가 없습니다</p>
      </div>
    ) : (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-3" data-testid="tools-list">
        {tools.map((tool) => (
          <div key={tool.id} className="p-3 bg-slate-50 rounded-lg border border-slate-200">
            <div className="flex items-center gap-2 mb-1">
              <Wrench size={14} className={tool.type === 'mcp' ? 'text-blue-600' : 'text-green-600'} />
              <span className="font-mono text-sm font-medium text-slate-700">{tool.name}</span>
              <span
                className={`text-[10px] px-1.5 py-0.5 rounded ${
                  tool.type === 'mcp' ? 'bg-blue-100 text-blue-700' : 'bg-green-100 text-green-700'
                }`}
              >
                {tool.type}
              </span>
            </div>
            <p className="text-xs text-slate-500 line-clamp-2">{tool.description}</p>
          </div>
        ))}
      </div>
    )}
  </div>
);
